import React, {useCallback, useEffect, useRef, useState} from 'react';
import {Link} from 'react-router-dom';
import {getTrails} from '../../../services/endpoints/contents/contents';
import {getTitle} from '../../Contents/Enum/categories';

const ObjectivesMenu = () => {
  const isMounted = useRef(true);
  const [loading, setLoading] = useState(true);
  const [contents, setContents] = useState([]);

  const loadContents = useCallback(async () => {
    const response = await getTrails();
    const {data} = response;
    setContents(data['hydra:member'] || []);
    setLoading(false);
  }, []);

  useEffect(() => {
    if (isMounted.current) {
      loadContents();
    }
    return () => {
      setLoading(true);
      isMounted.current = false;
    };
  }, [loadContents]);

  if (loading || !contents.length) {
    return null;
  }

  return (
    <li>
      <Link to="/cursos?by=objetivos">{getTitle('objetivos')}</Link>
      <ul>
        {contents.map((content) => (
          <li key={content['@id']}>
            <Link to={`/cursos?by=objetivos&typeFilter=${btoa(content['@id'])}`}>
              {content.title}
            </Link>
          </li>
        ))}
      </ul>
    </li>
  );
};

export default ObjectivesMenu;
